import { render, staticRenderFns } from "./fieldSetting.vue?vue&type=template&id=70311cbf&scoped=true"
import script from "./fieldSetting.vue?vue&type=script&lang=js"
export * from "./fieldSetting.vue?vue&type=script&lang=js"
import style0 from "./fieldSetting.vue?vue&type=style&index=0&id=70311cbf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70311cbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70311cbf')) {
      api.createRecord('70311cbf', component.options)
    } else {
      api.reload('70311cbf', component.options)
    }
    module.hot.accept("./fieldSetting.vue?vue&type=template&id=70311cbf&scoped=true", function () {
      api.rerender('70311cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/merbershipSystems/fieldSetting/fieldSetting.vue"
export default component.exports